const setInputValue = (element: HTMLInputElement, value: string) => {
  const setter = Object.getOwnPropertyDescriptor(
    HTMLInputElement.prototype,
    "value",
  )?.set;
  setter?.call(element, value);
  element.dispatchEvent(new Event("input", { bubbles: true }));
  element.dispatchEvent(new Event("change", { bubbles: true }));
};

export const prepopulateFormFields = (
  form: HTMLFormElement,
  data: Record<string, unknown>,
) => {
  for (const [key, rawValue] of Object.entries(data)) {
    if (rawValue === undefined || rawValue === null) continue;

    const value = String(rawValue);
    const elements = form.querySelectorAll<HTMLInputElement>(
      `[name="${CSS.escape(key)}"]`,
    );

    elements.forEach((element) => setInputValue(element, value));
  }
};
